import { Position } from './position';

export class SpectrogramData {
    public spectrogramValues: SpectrogramValue[];
    public overviewPath: Path[];

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.spectrogramValues = json.spectrogramValues.map((value: string) => new SpectrogramValue(value));
            if (json.overviewPath) {
                this.overviewPath = json.overviewPath.map((path: string) => new Path(path));
            }
        }
    }
}

export class SpectrogramValue {
    public time: string;
    public values: SpectrogramSectionValue[];

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.time = json.time;
            this.values = json.values.map((value: any) => new SpectrogramSectionValue(value));
        }
    }
}

export class SpectrogramSectionValue {
    public distance: number;
    public delay: number;
    public realTravelSpeed: number;
    public distanceInRoute: number;
    public startLocation: string;
    public endLocation: string;

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.distance = json.distance;
            this.delay = json.delay;
            this.realTravelSpeed = json.realTravelSpeed;
            this.distanceInRoute = json.distanceInRoute;
            this.startLocation = json.startLocation;
            this.endLocation = json.endlocation;
        }
    }
}

export class Path {
    public locations: Position[];

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.locations = json.locations.map((location: string) => new Position(location));
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/spectrogramData.ts